import React, {useCallback, useEffect, useRef, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {withTranslation} from 'react-i18next'

import useCartContext from 'components/Cart/useCartContext'
import useUserContext from 'components/User/useUserContext'
import SearchMain from 'modules/SearchMain'
import LogoAndLinks from 'modules/AppHeader/LogoAndLinks'

const navBarRoutes = ['search', 'category']
const shouldBeOpen = history => (navBarRoutes.indexOf(history.location.pathname.split('/')[1]) > -1)

const AppHeader = ({history, t}) => {
  const {user} = useUserContext()
  const {cart} = useCartContext()

  const [isOpen, setOpen] = useState(shouldBeOpen(history))
  const [isSearching, setSearching] = useState(false)
  const [resetSearchMain, setResetSearchMain] = useState(0)

  const timeout1 = useRef()
  const timeout2 = useRef()
  const onInteract = useCallback((focus, value) => {
    if (focus || value.length) {
      setSearching(true)
      setOpen(true)
      clearTimeout(timeout1.current)
      clearTimeout(timeout2.current)
      timeout1.current = setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.getElementsByTagName('body')[0].style.overflowY = 'hidden'
      }, 1000)
      timeout2.current = setTimeout(() => {
        document.documentElement.scrollTop = 0
      }, 1500)
    } else {
      setSearching(false)
      const open = shouldBeOpen(history)
      setOpen(open)
      if (!open) {
        clearTimeout(timeout1.current)
        clearTimeout(timeout2.current)
        document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
      }
    }
  }, [history])

  useEffect(() => {
    if (shouldBeOpen(history)) {
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden'
    }

    history.listen(() => {
      onInteract(false, '')
    })
  }, [history, onInteract])

  const closeSearchMain = () => {
    setResetSearchMain(r => r + 1)
    onInteract(false, '')
  }

  return (
    <nav id='nav' className={isOpen ? 'navCollapsed' : ''}>
      <div>
        <LogoAndLinks cart={cart} closeSearchMain={closeSearchMain} isSearching={isSearching} user={user} t={t}/>
        <div id='nav-autocomplete'>
          <SearchMain onInteract={onInteract} reset={resetSearchMain} isOpen={isOpen} isSearching={isSearching} setSearching={setSearching}/>
        </div>
      </div>
    </nav>
  )
}

export default withRouter(withTranslation()(AppHeader))
